import { Ng2StateDeclaration } from '@uirouter/angular';

export const AppStates: Array<Ng2StateDeclaration> = [
  {
    name: 'auth.**',
    url: '/auth',
    lazyLoad: () => import('./authentication/router/auth-states').then(m => m.AuthStatesLazyLoaded),
  },
  {
    name: 'main.tests.**',
    url: '/tests',
    lazyLoad: () => import('./tests/tests.module').then(m => m.TestStatesLazyLoaded),
  },
  {
    name: 'client.**',
    url: '/client',
    lazyLoad: () => import('./client/client.module').then(m => m.ClientStatesLazyLoaded),
  },
];
